// Developed by Softvative.com
import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const MetricCard = ({ title, value, icon, color }) => {
    const colorClasses = {
        blue: {
            bg: 'bg-blue-100 dark:bg-blue-900/20',
            icon: 'text-blue-600 dark:text-blue-400',
            gradient: 'from-blue-500 to-purple-600'
        },
        red: {
            bg: 'bg-red-100 dark:bg-red-900/20',
            icon: 'text-red-600 dark:text-red-400',
            gradient: 'from-red-500 to-orange-600'
        },
        green: {
            bg: 'bg-green-100 dark:bg-green-900/20',
            icon: 'text-green-600 dark:text-green-400',
            gradient: 'from-green-500 to-teal-600'
        },
        purple: {
            bg: 'bg-purple-100 dark:bg-purple-900/20',
            icon: 'text-purple-600 dark:text-purple-400',
            gradient: 'from-purple-500 to-indigo-600'
        },
        orange: {
            bg: 'bg-orange-100 dark:bg-orange-900/20',
            icon: 'text-orange-600 dark:text-orange-400',
            gradient: 'from-orange-500 to-red-600'
        }
    };

    const selectedColor = colorClasses[color] || colorClasses.blue;

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-5 flex items-center space-x-4"
        >
            <div className={`w-12 h-12 rounded-full flex items-center justify-center ${selectedColor.bg}`}>
                <div className={`w-10 h-10 rounded-full flex items-center justify-center bg-gradient-to-br ${selectedColor.gradient}`}>
                    <SafeIcon icon={icon} className="w-5 h-5 text-white" />
                </div>
            </div>
            <div>
                <p className="text-sm text-gray-600 dark:text-gray-400">{title}</p>
                <p className="text-2xl font-bold text-gray-900 dark:text-white">{value}</p>
            </div>
        </motion.div>
    );
};

export default MetricCard;